import styled from 'styled-components';
import { Grid } from 'semantic-ui-react';

const NoPaddingRow = styled(Grid.Row)`
  padding-top: 0 !important;
  padding-bottom: 0 !important;
`;

export default NoPaddingRow;
